import { SIA_GENERATING_FOLLOWUPS_URL_PARAM } from '@/utils/constants/sia';

export const setFollowupsModalOpen = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set(SIA_GENERATING_FOLLOWUPS_URL_PARAM, 'true');
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  window.history.replaceState({}, '', newUrl);
};

export const setFollowupsModalClosed = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(SIA_GENERATING_FOLLOWUPS_URL_PARAM);
  const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
  window.history.replaceState({}, '', newUrl);
};

export const isFollowupsModalOpen = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(SIA_GENERATING_FOLLOWUPS_URL_PARAM) === 'true';
};

export const useFollowupsModalState = () => {
  return {
    isOpen: isFollowupsModalOpen(),
    setOpen: setFollowupsModalOpen,
    setClosed: setFollowupsModalClosed,
  };
};
